import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { api } from '@/lib/api';
import type { AccountDriveFilesResponse } from '@/features/accounts/api';

export const opportunityDriveKeys = {
  all: ['opportunity-drive-files'] as const,
  folder: (opportunityId: string) => [...opportunityDriveKeys.all, opportunityId] as const,
};

export function useOpportunityDriveFiles(opportunityId: string) {
  return useQuery({
    queryKey: opportunityDriveKeys.folder(opportunityId),
    queryFn: () => api.get<AccountDriveFilesResponse>(`/v4/opportunities/${opportunityId}/drive-files`),
    enabled: !!opportunityId,
  });
}

export function useSetOpportunityDriveFolder(opportunityId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (gdriveFolderId: string | null) =>
      api.patch(`/v4/opportunities/${opportunityId}`, { gdriveFolderId }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: opportunityDriveKeys.folder(opportunityId) });
      queryClient.invalidateQueries({ queryKey: ['opportunity', opportunityId] });
      toast.success('Drive folder updated');
    },
    onError: (error) => {
      toast.error(error instanceof Error ? error.message : 'Failed to update Drive folder');
    },
  });
}
